import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  processStatus = new BehaviorSubject<ProcessStatus>(new ProcessStatus(ProcessStatusEnum.complete));

  constructor() { }

  public updateStatus(newProcessStatus: ProcessStatus) {
    this.processStatus.next(newProcessStatus);
  }
}

/**
 * Rappresento lo stato di un processo dove è eventualmente possibile associare
 * un messaggio da mostrare all'utente (ad esempio un toast)
 */
export class ProcessStatus {
  status: ProcessStatusEnum;
  message?: string;
  toastClassName?: string;

  constructor(status: ProcessStatusEnum, message?: string, toastClassName?: string) {
    this.status = status;
    this.message = message;
    this.toastClassName = toastClassName;
  }
}

export enum ProcessStatusEnum {
  complete,
  pending
}


